import { Component } from '@angular/core';
import { CoreComponent } from "./app-core/ui/core/core";

@Component({
  selector: 'app-root',
  imports: [CoreComponent],
  templateUrl: './app.html',
})
export class App { }
